export enum TipoBeneficiarioEnum {
  PERSONA_FISICA = <any>"PERSONA_FISICA",
  PERSONA_GIURIDICA = <any>"PERSONA_GIURIDICA", 
  DITTA_INDIVIDUALE = <any>"DITTA_INDIVIDUALE"
}

export const TipoBeneficiarioLabelMapping = {
  [TipoBeneficiarioEnum.PERSONA_FISICA]: "Persona fisica",
  [TipoBeneficiarioEnum.PERSONA_GIURIDICA]: "Persona giuridica",
  [TipoBeneficiarioEnum.DITTA_INDIVIDUALE]: "Ditta individuale"
};